// fany box

$(document).ready(function () {
  //Submenu Dropdown Toggle
  if ($(".main-header li.dropdown ul").length) {
    $(".main-header .navigation li.dropdown").append(
      '<div class="dropdown-btn"><span class="fa fa-angle-right"></span></div>'
    );
  }

  //Mobile Nav Hide Show
  if ($(".mobile-menu").length) {
    // $('.mobile-menu .menu-box').mCustomScrollbar();

    //Dropdown Button
    $(".mobile-menu li.dropdown .dropdown-btn").on("click", function () {
      $(this).toggleClass("open");
      $(this).prev("ul").slideToggle(500);
    });
    //Menu Toggle Btn
    $(".mobile-nav-toggler,.extend-nav-toggler").on("click", function () {
      $("body").addClass("mobile-menu-visible");
    });

    //Menu Toggle Btn
    $(".mobile-menu .menu-backdrop,.mobile-menu .close-btn").on(
      "click",
      function () {
        $("body").removeClass("mobile-menu-visible");
      }
    );
    $(document).keydown(function (e) {
      if (e.keyCode === 27) {
        $("#search-popup").removeClass("mobile-menu-visible");
        $("body").removeClass("mobile-menu-visible");
      }
    });
  }

  //Update Header Style and Scroll to Top
  function headerStyle() {
    if ($(".main-header").length) {
      var windowpos = $(window).scrollTop();
      var siteHeader = $(".main-header");
      var scrollLink = $(".scroll-to-top");
      var sticky_header = $(".main-header .sticky-header");
      if (windowpos >= 100) {
        siteHeader.addClass("fixed-header");
        $("body").addClass("fix-header");
        sticky_header.addClass("animated slideInDown");
        scrollLink.fadeIn(500);
      } else {
        $("body").removeClass("fix-header");
        siteHeader.removeClass("fixed-header");
        sticky_header.removeClass("animated slideInDown");
        scrollLink.fadeOut(300);
      }
    }
  }
  headerStyle();

  $(window).on("scroll", function () {
    headerStyle();
  });

  //Search Popup
  if ($("#search-popup").length) {
    //Show Popup
    $(".search-toggler").on("click", function () {
      $("#search-popup").addClass("popup-visible");
      $("body").addClass("search-visible");
    });
    $(document).keydown(function (e) {
      if (e.keyCode === 27) {
        $("#search-popup").removeClass("popup-visible");
        $("body").removeClass("search-visible");
      }
    });
    //Hide Popup
    $(".close-search,.search-popup .overlay-layer").on("click", function () {
      $("#search-popup").removeClass("popup-visible");
      $("body").removeClass("search-visible");
    });
  }

  //Hidden Bar Menu Config
  function hiddenBarMenuConfig() {
    var menuWrap = $(".hidden-bar .side-menu");
    // hidding submenu
    menuWrap.find(".dropdown").children("ul").hide();
    // toggling child ul
    menuWrap.find("li.dropdown > a").each(function () {
      $(this).on("click", function (e) {
        e.preventDefault();
        $(this).parent("li.dropdown").children("ul").slideToggle();

        // adding class to item container
        $(this).parent().toggleClass("open");

        return false;
      });
    });
  }

  hiddenBarMenuConfig();

  //Hidden Sidebar
  if ($(".hidden-bar").length) {
    var hiddenBar = $(".hidden-bar");
    var hiddenBarOpener = $(".max-nav-toggler .toggle-btn");
    var hiddenBarCloser = $(".hidden-bar-closer");
    // $('.hidden-bar-wrapper').mCustomScrollbar();

    //Show Sidebar
    hiddenBarOpener.on("click", function () {
      hiddenBar.addClass("visible-sidebar");
    });

    //Hide Sidebar
    hiddenBarCloser.on("click", function () {
      hiddenBar.removeClass("visible-sidebar");
    });

    $(document).keydown(function (e) {
      if (e.keyCode === 27) {
        hiddenBar.removeClass("visible-sidebar");
      }
    });
  }

  setTimeout(function () {
    $(".preloader").hide();
  }, 2200);

  if ($(".lightbox-image").length) {
    $(".lightbox-image").fancybox({
      openEffect: "fade",
      closeEffect: "fade",
      helpers: {
        media: {},
      },
    });
  }
  //Product Tabs

  if ($(".project-tab").length) {
    $(".project-tab .product-tab-btns .p-tab-btn").on("click", function (e) {
      e.preventDefault();
      var target = $($(this).attr("data-tab"));
      if ($(target).hasClass("actve-tab")) {
        return false;
      } else {
        $(this)
          .parents(".project-tab")
          .find(".product-tab-btns .p-tab-btn")
          .removeClass("active-btn");
        $(this).addClass("active-btn");
        $(this)
          .parents(".project-tab")
          .find(".p-tabs-content .p-tab")
          .removeClass("active-tab");
        $(target).addClass("active-tab");
      }
    });
  }


  // SERVICE SECTION
  if ($(".tabs-box").length) {
    $(".tabs-box .tab-buttons .tab-btn").on("click", function (e) {
      e.preventDefault();
      var target = $($(this).attr("data-tab"));

      if ($(target).is(":visible")) {
        return false;
      } else {
        target
          .parents(".tabs-box")
          .find(".tab-buttons")
          .find(".tab-btn")
          .removeClass("active-btn");
        $(this).addClass("active-btn");
        target
          .parents(".tabs-box")
          .find(".tabs-content")
          .find(".tab")
          .fadeOut(0);
        target
          .parents(".tabs-box")
          .find(".tabs-content")
          .find(".tab")
          .removeClass("active-tab");
        $(target).fadeIn(300);
        $(target).addClass("active-tab");
      }
    });
  }

  //Jquery Knob animation
  if ($(".dial").length) {
    $(".dial").appear(
      function () {
        var elm = $(this);
        var color = elm.attr("data-fgColor");
        var perc = elm.attr("value");
        console.log(elm.attr("value"));
        var thickness = elm.attr("data-thickness");

        elm.knob({
          value: 0,
          min: 0,
          max: 100,
          skin: "tron",
          readOnly: true,
          thickness: thickness,
          dynamicDraw: true,
          displayInput: false,
        });

        $({ value: 0 }).animate(
          { value: perc },
          {
            duration: 2000,
            easing: "swing",
            progress: function () {
              elm.val(Math.ceil(this.value)).trigger("change");
            },
          }
        );
      },
      { accY: 0 }
    );
  }

  //Progress Bar
  if ($(".progress-line").length) {
    $(".progress-line").appear(
      function () {
        var el = $(this);
        var percent = el.data("width");
        $(el).css("width", percent + "%");
      },
      { accY: 0 }
    );
  }

  //Fact Counter + Text Count
  if ($(".count-box").length) {
    $(".count-box").appear(
      function () {
        var $t = $(this),
          n = $t.find(".count-text").attr("data-stop"),
          r = parseInt($t.find(".count-text").attr("data-speed"), 10);

        if (!$t.hasClass("counted")) {
          $t.addClass("counted");
          $({
            countNum: $t.find(".count-text").text(),
          }).animate(
            {
              countNum: n,
            },
            {
              duration: r,
              easing: "linear",
              step: function () {
                $t.find(".count-text").text(Math.floor(this.countNum));
              },
              complete: function () {
                $t.find(".count-text").text(this.countNum);
              },
            }
          );
        }
      },
      { accY: 0 }
    );
  }
});
